import React from 'react';
import Card from './Card';
import './AssessmentPreparingScreen.css';

export default function AssessmentPreparingScreen({ checking = false, fetching = false }) {
  const message = checking ? '正在准备测评，请稍等' : fetching
    ? '正在加载测评题目，请稍等' : 'AI正在为您生成专属测评题目，请稍等';
  return (
    <div className="assessment-preparing">
      <Card className="assessment-preparing-card" padding="clamp(36px, 7vw, 64px) clamp(20px, 5vw, 40px) 28px">
        <div className="assessment-preparing-mark" aria-hidden="true">
          <span className="assessment-preparing-ring" />
          <span className="assessment-preparing-core">AI</span>
        </div>
        <div role="status" aria-live="polite" aria-atomic="true">
          <h1>{message}</h1>
          <p>题目就绪后将自动进入作答</p>
        </div>
        <div className="assessment-preparing-note">AI 领导力测评 · 专注于您的管理实践</div>
      </Card>
    </div>
  );
}
